module.exports = __webpack_public_path__ + "static/media/category-interesting.58db8c58.svg";